import React from "react";
import "../assets/styles/techstack.css";
import Marquee from "react-fast-marquee";

import t1 from "../assets/images/t1.png";
import t2 from "../assets/images/t2.png";
import t3 from "../assets/images/t3.png";
import t4 from "../assets/images/t4.png";
import t5 from "../assets/images/t5.png";
import t6 from "../assets/images/t6.png";
import t7 from "../assets/images/t7.png";
import t8 from "../assets/images/t8.png";
import t9 from "../assets/images/t9.png";
import t10 from "../assets/images/t10.png";
import ser1 from "../assets/images/ser1.svg";
import ser2 from "../assets/images/ser2.svg";

const techLogos = [
  { src: t1, alt: "MongoDB", isLarge: true },
  { src: t2, alt: "Express" },
  { src: t3, alt: "React", isLarge: true },
  { src: t4, alt: "Node.js" },
  { src: t5, alt: "React", isLarge: true },
  { src: t6, alt: "Node.js" },
  { src: t7, alt: "React", isLarge: true },
  { src: t8, alt: "Node.js" },
  { src: t9, alt: "React", isLarge: true },
  { src: t10, alt: "Node.js" },
];

const TechStack = () => {
  const logosToRender = [...techLogos, ...techLogos]; // duplicate for infinite loop

  return (
    <section className="techstack-section">
      <div className="techstack-header">
        <h2 className="services-title">
          <div className="line-container">
            <img src={ser1} alt="Line 1" className="line" />
            <img src={ser2} alt="Line 2" className="line" />
            Tech Stack
          </div>
        </h2>
        <p className="techstack-description">
          At Syncrones, we leverage the latest technologies to ensure excellence
          and innovation in every project.
        </p>
      </div>

      <div className="techstack-slider">
        <div className="techstack-track">
        <Marquee
        speed={50} // Adjust scroll speed
        pauseOnHover={false}
        gradient={false}
        className="marquee-container"
      >
        {techLogos.map((logo, index) => (
          <div
            key={index}
            className={`techstack-logo ${logo.isLarge ? "techstack-logo-large" : ""}`}
          >
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </Marquee>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
